<template>
  <h1>Dashboard</h1>
  <p>Welcome to the Dashboard!</p>  
</template>

<script lang="ts" setup>
  //#region Imports
  //#endregion
</script>
